export default __webpack_public_path__ + "static/media/hotel_thumbnail.a3251c78.png";